var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1367 3.68945V14.0004",
    stroke: "#217EE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86182 3.68945V14.0004",
    stroke: "#217EE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2676 3.68848H2.73241C1.77563 3.68848 1 4.31871 1 5.09615V12.5918C1 13.3692 1.77563 13.9995 2.73241 13.9995H15.2676C16.2244 13.9995 17 13.3692 17 12.5918V5.09615C17 4.31871 16.2244 3.68848 15.2676 3.68848Z",
    stroke: "#217EE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0195 3.68983C12.0251 3.61518 12.0251 3.54032 12.0195 3.46567C12.0195 2.81174 11.6998 2.18458 11.1307 1.72218C10.5616 1.25978 9.78981 1 8.98501 1C8.18022 1 7.40838 1.25978 6.83931 1.72218C6.27023 2.18458 5.95053 2.81174 5.95053 3.46567C5.94488 3.54032 5.94488 3.61518 5.95053 3.68983",
    stroke: "#217EE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuJobs);
export default __webpack_public_path__ + "static/media/menu-jobs.f72098b022d62c7319cab7cccc87436c.svg";
export { ForwardRef as ReactComponent };